import React from 'react';

//TODO: Mergear con webcore componentes genéricos
import { GenericOption/*, GenericSelect */ } from 'com-gyf-webcore-userinterfacecomponents';
import GenericSelect from '../../../Packages/SharedComponents/Com.Gyf.WebCore.GenericSelect.jsx';

const TableHeader = (props) => {
    let productoValue;
    let oProducts = props.productos.map(function (producto) {
        if (producto.Id == props.filter.product) {
            productoValue = producto.Id;
        }
        return <GenericOption id={producto.Id} description={producto.Descripcion} key={"ProdOp_" + producto.Id} />;
    });

    let categorias = props.categorias.filter(x => x.Id == 0 || x.ProductoId == props.filter.product);
    let categoriaValue;
    let oCategories = categorias.map(function (categoria) {
        if (categoria.Id == props.filter.category) {
            categoriaValue = categoria.Id;
        }
        return <GenericOption id={categoria.Id} description={categoria.Descripcion} key={"CatOp_" + categoria.Id} />;
    });

    let programas = props.programas.filter(x => x.Id == 0 || x.CategoriaId == props.filter.category);
    let programaValue;
    let oPrograms = programas.map(function (programa) {
        if (programa.Id == props.filter.program) {
            programaValue = programa.Id;
        }
        return <GenericOption id={programa.Id} description={programa.Descripcion} key={"ProgOp_" + programa.Id} />;
    });

    return (
        <thead>
            <tr>
                <th className="th1">
                    <label>
                        PERFIL
                    </label>
                </th>
                <th className="th2">
                    <label>
                        PERMISOS EN
                    </label>
                </th>
                <th className="th3 bottom-padding-xxs">
                    <GenericSelect id="selProductos" options={oProducts} value={productoValue} onChange={(e) => { props.selectProducto(e.target.value) }}
                        class={"form-control default-select"} />
                </th>
                <th className="th3 bottom-padding-xxs">
                    <GenericSelect id="selCategoria" options={oCategories} value={categoriaValue} onChange={(e) => { props.selectCategoria(e.target.value) }}
                        class={"form-control default-select"} />
                </th>
                <th className="bottom-padding-xxs">
                    <GenericSelect id="selProgramas" options={oPrograms} value={programaValue} onChange={(e) => { props.selectPrograma(e.target.value) }}
                        class={"form-control default-select"} />
                </th>
            </tr>
        </thead>
    );
}

export default TableHeader;